import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".element-largecallout").forEach((el) => {
  const chars = el.querySelectorAll(".element-headline .word em");
  const container = el.querySelector(".element-container");

  gsap
    .timeline({
      scrollTrigger: {
        trigger: container,
        start: () => `top ${getComputedStyle(document.documentElement).getPropertyValue("--site-header-stuck-height").trim() || 0}`,
        end: "bottom+=20% center",
        anticipatePin: true,
        pin: true,
        scrub: 2,
        invalidateOnRefresh: true,
        refreshPriority: 1,
        markers: false,
      },
    })
    .fromTo(chars, { color: "rgba(255,255,255,0.2)" }, { color: "rgba(255,255,255,1)", ease: "none", stagger: 0.2 });
});
